// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3iiyq","right":"Footer_right__1BG3J","buttons":"Footer_buttons__24Pm2"};